import * as R from 'ramda';
import i18n from 'helpers/i18n';
import messages from './messages';
import { useEffect } from 'react';
import useAsync from 'hooks/useAsync';
import ReminderIcon from './ReminderIcon';
import { Action } from 'types/api/Action';
import { Button } from '@teachstonellc/component-library';
import { getActions } from 'actions/actions';
import ActionsIcon from 'images/actions.svg';
import { getUserTimeZone, parseToDateTime } from 'helpers/date/localTimezone';

import {
  Header,
  ReminderWrapper,
  DetailsWrapper,
  ButtonWrapper,
  TypeLabel,
  Title,
  Subtitle,
  EmptyText
} from './Styled';

function Reminders() {
  const { run, data, isPending, isSuccess } = useAsync();

  useEffect(() => {
    run(getActions());
  }, [run]);

  if (!isSuccess) {
    return null;
  }

  if (isPending) {
    return null;
  }

  function formatSubtitle(subtitle: string) {
    if (!subtitle) {
      return '';
    }

    const dt = parseToDateTime(subtitle);
    if (!dt) return null;

    const converted = dt.setZone(getUserTimeZone());
    const dateString = converted.toLocaleString({
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    });
    const timeString = converted.toLocaleString({
      hour: '2-digit',
      minute: '2-digit',
      hour12: undefined
    });

    return (
      <div>
        <div>{dateString}</div>
        {timeString}
      </div>
    );
  }

  function navigateToActionLink(link: string) {
    let url;
    try {
      url = new URL(link, window.location.origin);
    } catch {
      return;
    }

    if (url.protocol === 'http:' || url.protocol === 'https:') {
      window.location.href = url.toString();
    }
  }

  function isCalibrationAvailable(action: Action) {
    if (action.type !== 'calibration' || !action.available_at) {
      return false;
    }

    const availableDate: Date = new Date(action.available_at);
    const currentDate: Date = new Date(Date.now());

    return availableDate?.getTime() > currentDate?.getTime();
  }

  return (
    <div>
      <Header>
        <img src={ActionsIcon} alt="" className="inline" />
        {i18n.ft(messages.header)}
      </Header>

      {R.isEmpty(data) && <EmptyText>{i18n.ft(messages.noActions)}</EmptyText>}

      {data.map((action: Action, idx: number) => (
        <ReminderWrapper key={idx}>
          <DetailsWrapper>
            <ReminderIcon action={action} />
            <div>
              <TypeLabel>{action.type_label}</TypeLabel>
              <Title>{action.title}</Title>
              <Subtitle>{action.subtitle_header}</Subtitle>
              {formatSubtitle(action.subtitle)}
            </div>
          </DetailsWrapper>

          <ButtonWrapper>
            <Button
              fullWidth
              variant="aux"
              size="small"
              disabled={isCalibrationAvailable(action)}
              onClick={() => navigateToActionLink(action.link)}
            >
              {action.link_title}
            </Button>
          </ButtonWrapper>
        </ReminderWrapper>
      ))}
    </div>
  );
}

export default Reminders;
